import { createFileRoute } from "@tanstack/react-router";
import AdminCriterionNewPage from "@/pages/admin/criteria/new";
import { useCriteriaPermissions } from "@/pages/admin/criteria";

export const Route = createFileRoute("/app/admin/criteria/new")({
  component: RouteComponent,
});

function RouteComponent() {
  const { currentUser, userCanEditAllCriteria, userCanViewAllCriteria } = useCriteriaPermissions();

  return (
    <AdminCriterionNewPage
      currentUser={currentUser}
      userCanEditAllCriteria={userCanEditAllCriteria}
      userCanViewAllCriteria={userCanViewAllCriteria}
    />
  );
}
